/** Meta custom + GA4 for Magic landing primary CTAs. */
export function trackMagicCtaClick(cta: string) {
  if (typeof window.fbq === "function") {
    window.fbq("trackCustom", "MagicCtaClick", { cta });
  }
  window.gtag?.("event", "magic_cta_click", {
    cta,
    page_location: window.location.href,
  });
}

export function trackMagicBookEventClick() {
  trackMagicCtaClick("book_event");
}

export function trackMagicShowsClick() {
  trackMagicCtaClick("see_shows");
}

export function trackMagicInstagramClick() {
  trackMagicCtaClick("follow_instagram");
}
